var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "text-field" }, [
    !_vm.hideLabel && _vm.label
      ? _c("label", { class: { "required-flag": _vm.required } }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.label) +
              _vm._s(_vm.showColon ? ":" : "") +
              "\n  "
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.readonlyAsInput && _vm.readonly && (_vm.value || _vm.defaultEmpty)
      ? _c("pre", [_c("p", [_vm._v(_vm._s(_vm.value || "--"))])])
      : _vm._e(),
    _vm._v(" "),
    _vm.readonlyAsInput || !_vm.readonly
      ? _c("div", { staticClass: "row text-input" }, [
          _vm.hintBeforeInput
            ? _c("p", { class: _vm.hintClass }, [
                _vm._v("\n      " + _vm._s(_vm.hintBeforeInput) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              { name: "autosize", rawName: "v-autosize" },
              {
                name: "hkldinput",
                rawName: "v-hkldinput",
                value: {
                  component: _vm.parentNode,
                  unchecked: !_vm.dirtyCheck,
                },
                expression: "{ component: parentNode, unchecked: !dirtyCheck }",
              },
              {
                name: "fusioninputcheck",
                rawName: "v-fusioninputcheck",
                value: {
                  type: "string",
                  tip: _vm.inputTip,
                  required: _vm.required,
                },
                expression: "{type: 'string', tip: inputTip, required}",
              },
            ],
            staticClass: "autosize",
            class: [
              { "small-2 medium-2 large-2 columns": _vm.text },
              _vm.extendClass,
            ],
            attrs: {
              disabled: _vm.readonlyAsInput,
              placeholder: _vm.placeholder,
              required: _vm.required,
            },
            domProps: { value: _vm.value },
            on: {
              change: function (event) {
                return _vm.$emit("updateValue", event.target.value)
              },
              input: _vm.onInput,
              focusout: _vm.afterBlur,
            },
          }),
          _vm._v(" "),
          _c("pre", [
            _vm.text
              ? _c("p", { staticClass: "additional-text" }, [
                  _vm._v(_vm._s(_vm.text)),
                ])
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }